import { BasicResponse, PagedResponse } from '../types';
import { DasRPAlert, RequestAlertsParams } from '../types/Alert';
import { DasRP } from '../types/Device';

import DsmAxios from './DsmAxios';

export const getDasRPsProject = (projectId: string) => {
  return DsmAxios.get<PagedResponse<DasRP>>(`v1/projects/${projectId}/dasrps`);
};

export const getUserDasRPs = (params?: {
  id?: string;
  dasId?: string;
  projectId?: string;
  assignedProject?: boolean;
  nextCursor?: string;
  limit?: number;
}) => {
  return DsmAxios.get<PagedResponse<DasRP>>('v1/dasrps', {
    params,
  });
};

export const getProjectDasRPs = (data: {
  projectId: string;
  params?: {
    dasId?: string;
    assignedProject?: boolean;
    id?: string;
    limit?: number;
    nextCursor?: string;
    prevCursor?: string;
  };
}) => {
  return DsmAxios.get<PagedResponse<DasRP>>(
    `v1/projects/${data.projectId}/dasrps`,
    {
      params: data.params,
    },
  );
};

export const getDastrackByDasId = (data: { dasId: string }) => {
  return DsmAxios.get<BasicResponse<DasRP>>(`v1/dasrps/${data.dasId}`);
};

type UnbindDastrackParam = {
  projectId: string;
  dasId: string;
};

export const unbindDasRP = (obj: UnbindDastrackParam) => {
  return DsmAxios.delete(
    `v1/projects/${obj.projectId}/dasrps/${obj.dasId}/plant`,
  );
};

interface BindDasRPToPlantParam {
  projectId: string;
  dasId: string;
  data: {
    plantId: string;
  };
}

export const bindDasRPToPlant = ({
  projectId,
  dasId,
  data,
}: BindDasRPToPlantParam) => {
  return DsmAxios.put<any>(
    `v1/projects/${projectId}/dasrps/${dasId}/plant`,
    data,
  );
};

export const getDasRPAlerts = (
  projectId: string,
  params?: RequestAlertsParams & { plantId?: string },
) => {
  return DsmAxios.get<PagedResponse<DasRPAlert>>(
    `v1/projects/${projectId}/dasrp-alerts`,
    { params },
  );
};

export const dismissDasRPAlert = (projectId: string, alertId: string) => {
  return DsmAxios.post(
    `v1/projects/${projectId}/dasrp-alerts/${alertId}/dismiss`,
  );
};

export const readDasRPAlert = (projectId: string, alertId: string) => {
  return DsmAxios.post(`v1/projects/${projectId}/dasrp-alerts/${alertId}/read`);
};

export const undismissDasRPAlert = (projectId: string, alertId: string) => {
  return DsmAxios.post(
    `v1/projects/${projectId}/dasrp-alerts/${alertId}/undismiss`,
  );
};

export const dismissOrReadAllDasRPAlert = ({
  projectId,
  action,
}: {
  projectId: string;
  action: 'read' | 'dismiss';
}) => {
  return DsmAxios.post(`v1/projects/${projectId}/dasrp-alerts/${action}/all`);
};
